import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Icon, notification, Divider, Button, DatePicker } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const parseArray = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const getErrorMessage = error => {
    const data = error?.response?.data;

    if (!data) return "Ocorreu um erro inesperado.";
    if (typeof data === "string") return data;

    if (data.title && data.errors) {
        const validationMessages = Object.values(data.errors).flat().join(" | ");
        return `${data.title}${validationMessages ? `: ${validationMessages}` : ""}`;
    }

    if (data.title) return data.title;

    return "Ocorreu um erro inesperado.";
};

const ListaDesempenhoArea = ({ value = [], onChange }) => {
    const lista =
        value.length > 0
            ? value
            : [
                  {
                      disciplina: "",
                      desenvolvimento: "",
                      avancos: "",
                      dificuldades: "",
                      observacoes: ""
                  }
              ];

    const handleChange = (index, field, fieldValue) => {
        const novaLista = [...lista];
        novaLista[index] = {
            ...novaLista[index],
            [field]: fieldValue
        };
        onChange && onChange(novaLista);
    };

    const handleAdd = () => {
        const novaLista = [
            ...lista,
            {
                disciplina: "",
                desenvolvimento: "",
                avancos: "",
                dificuldades: "",
                observacoes: ""
            }
        ];
        onChange && onChange(novaLista);
    };

    const handleRemove = index => {
        const novaLista = lista.filter((_, i) => i !== index);
        onChange &&
            onChange(
                novaLista.length
                    ? novaLista
                    : [
                          {
                              disciplina: "",
                              desenvolvimento: "",
                              avancos: "",
                              dificuldades: "",
                              observacoes: ""
                          }
                      ]
            );
    };

    return (
        <div>
            {lista.map((item, index) => (
                <div
                    key={index}
                    style={{
                        border: "1px solid #e8e8e8",
                        padding: 12,
                        marginBottom: 12,
                        borderRadius: 4,
                        backgroundColor: "#fcfcfc"
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <strong>{index + 1}. Área curricular</strong>
                        {lista.length > 1 && <Button type="danger" size="small" ghost icon="minus" onClick={() => handleRemove(index)} />}
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Disciplina</label>
                        <Input value={item.disciplina} onChange={e => handleChange(index, "disciplina", e.target.value)} />
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Desenvolvimento</label>
                        <TextArea
                            rows={3}
                            value={item.desenvolvimento}
                            onChange={e => handleChange(index, "desenvolvimento", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Avanços</label>
                        <TextArea
                            rows={3}
                            value={item.avancos}
                            onChange={e => handleChange(index, "avancos", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Dificuldades</label>
                        <TextArea
                            rows={3}
                            value={item.dificuldades}
                            onChange={e => handleChange(index, "dificuldades", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 0 }}>
                        <label>Observações</label>
                        <TextArea
                            rows={3}
                            value={item.observacoes}
                            onChange={e => handleChange(index, "observacoes", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>
                </div>
            ))}

            <Button type="dashed" icon="plus" onClick={handleAdd} style={{ width: "100%" }}>
                Adicionar área curricular
            </Button>
        </div>
    );
};

const ListaIntervencoesSRM = ({ value = [], onChange }) => {
    const lista =
        value.length > 0
            ? value
            : [
                  {
                      atividade: "",
                      frequencia: "",
                      resultados: "",
                      sugestoes: ""
                  }
              ];

    const handleChange = (index, field, fieldValue) => {
        const novaLista = [...lista];
        novaLista[index] = {
            ...novaLista[index],
            [field]: fieldValue
        };
        onChange && onChange(novaLista);
    };

    const handleAdd = () => {
        const novaLista = [
            ...lista,
            {
                atividade: "",
                frequencia: "",
                resultados: "",
                sugestoes: ""
            }
        ];
        onChange && onChange(novaLista);
    };

    const handleRemove = index => {
        const novaLista = lista.filter((_, i) => i !== index);
        onChange &&
            onChange(
                novaLista.length
                    ? novaLista
                    : [
                          {
                              atividade: "",
                              frequencia: "",
                              resultados: "",
                              sugestoes: ""
                          }
                      ]
            );
    };

    return (
        <div>
            {lista.map((item, index) => (
                <div
                    key={index}
                    style={{
                        border: "1px solid #e8e8e8",
                        padding: 12,
                        marginBottom: 12,
                        borderRadius: 4,
                        backgroundColor: "#fcfcfc"
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <strong>{index + 1}. Intervenção SRM</strong>
                        {lista.length > 1 && <Button type="danger" size="small" ghost icon="minus" onClick={() => handleRemove(index)} />}
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Atividade</label>
                        <TextArea
                            rows={2}
                            value={item.atividade}
                            onChange={e => handleChange(index, "atividade", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Frequência</label>
                        <Input
                            value={item.frequencia}
                            onChange={e => handleChange(index, "frequencia", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label>Resultados</label>
                        <TextArea
                            rows={3}
                            value={item.resultados}
                            onChange={e => handleChange(index, "resultados", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>

                    <div style={{ marginBottom: 0 }}>
                        <label>Sugestões</label>
                        <TextArea
                            rows={3}
                            value={item.sugestoes}
                            onChange={e => handleChange(index, "sugestoes", e.target.value)}
                            style={{ minHeight: 100 }}
                        />
                    </div>
                </div>
            ))}

            <Button type="dashed" icon="plus" onClick={handleAdd} style={{ width: "100%" }}>
                Adicionar intervenção
            </Button>
        </div>
    );
};

const DrawerRelatorioIrandubaFundamental = ({ id, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        apresentacao: {
            ano_letivo: "",
            bimestre: "",
            aluno: "",
            data_nascimento: null,
            serie_turma: "",
            professor_srm: "",
            pedagogo_coordenador: "",
            responsaveis_legais: ""
        },
        desempenho_academico_por_area_curricular: [
            {
                disciplina: "",
                desenvolvimento: "",
                avancos: "",
                dificuldades: "",
                observacoes: ""
            }
        ],
        intervencoes_na_sala_recursos_multifuncionais: [
            {
                atividade: "",
                frequencia: "",
                resultados: "",
                sugestoes: ""
            }
        ],
        consideracoes_gerais: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const { getFieldDecorator, setFieldsValue, resetFields } = form;

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                if (id) {
                    alterarRelatorio(values);
                } else {
                    adicionarRelatorio(values);
                }
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/relatorio-individual/carregar-relatorio-individual-fundamental",
            params: { id }
        })
            .then(response => {
                const data = response.data || {};

                const apresentacao = parseObject(data.apresentacao, estadoInicial.apresentacao);

                const dados = {
                    apresentacao: {
                        ano_letivo: apresentacao.ano_letivo || "",
                        bimestre: apresentacao.bimestre || "",
                        aluno: apresentacao.aluno || "",
                        data_nascimento: apresentacao.data_nascimento ? moment(apresentacao.data_nascimento) : null,
                        serie_turma: apresentacao.serie_turma || "",
                        professor_srm: apresentacao.professor_srm || "",
                        pedagogo_coordenador: apresentacao.pedagogo_coordenador || "",
                        responsaveis_legais: apresentacao.responsaveis_legais || ""
                    },
                    desempenho_academico_por_area_curricular: parseArray(
                        data.desempenho_academico_por_area_curricular,
                        estadoInicial.desempenho_academico_por_area_curricular
                    ),
                    intervencoes_na_sala_recursos_multifuncionais: parseArray(
                        data.intervencoes_na_sala_recursos_multifuncionais,
                        estadoInicial.intervencoes_na_sala_recursos_multifuncionais
                    ),
                    consideracoes_gerais: data.consideracoes_gerais || ""
                };

                setRegisto(dados);

                setFieldsValue({
                    apresentacao_ano_letivo: dados.apresentacao.ano_letivo,
                    apresentacao_bimestre: dados.apresentacao.bimestre,
                    apresentacao_aluno: dados.apresentacao.aluno,
                    apresentacao_data_nascimento: dados.apresentacao.data_nascimento,
                    apresentacao_serie_turma: dados.apresentacao.serie_turma,
                    apresentacao_professor_srm: dados.apresentacao.professor_srm,
                    apresentacao_pedagogo_coordenador: dados.apresentacao.pedagogo_coordenador,
                    apresentacao_responsaveis_legais: dados.apresentacao.responsaveis_legais,
                    desempenho_academico_por_area_curricular: dados.desempenho_academico_por_area_curricular,
                    intervencoes_na_sala_recursos_multifuncionais: dados.intervencoes_na_sala_recursos_multifuncionais,
                    consideracoes_gerais: dados.consideracoes_gerais
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", getErrorMessage(error));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarRelatorio = values => {
        setIsLoading(true);

        let item = new FormData();
        item.append("id", id);
        item.append("id_disciplina", localStorage.getItem("codigo_curso"));
        item.append("tipo", "relatorio_bimestral_fundamental");

        item.append(
            "apresentacao",
            JSON.stringify({
                ano_letivo: values.apresentacao_ano_letivo,
                bimestre: values.apresentacao_bimestre,
                aluno: values.apresentacao_aluno,
                data_nascimento: values.apresentacao_data_nascimento,
                serie_turma: values.apresentacao_serie_turma,
                professor_srm: values.apresentacao_professor_srm,
                pedagogo_coordenador: values.apresentacao_pedagogo_coordenador,
                responsaveis_legais: values.apresentacao_responsaveis_legais
            })
        );

        item.append(
            "desempenho_academico_por_area_curricular",
            JSON.stringify(values.desempenho_academico_por_area_curricular || estadoInicial.desempenho_academico_por_area_curricular)
        );
        item.append(
            "intervencoes_na_sala_recursos_multifuncionais",
            JSON.stringify(
                values.intervencoes_na_sala_recursos_multifuncionais || estadoInicial.intervencoes_na_sala_recursos_multifuncionais
            )
        );
        item.append("consideracoes_gerais", values.consideracoes_gerais);

        axios({
            method: "post",
            url: "/api/relatorio-individual/adicionar-relatorio-individual-fundamental",
            data: item
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Relatório criado.");
                atualizarListagem();
                handleClose();
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    };

    const alterarRelatorio = values => {
        setIsLoading(true);

        let item = new FormData();
        item.append("id", id);
        item.append("id_disciplina", localStorage.getItem("codigo_curso"));
        item.append("tipo", "relatorio_bimestral_fundamental");

        item.append(
            "apresentacao",
            JSON.stringify({
                ano_letivo: values.apresentacao_ano_letivo,
                bimestre: values.apresentacao_bimestre,
                aluno: values.apresentacao_aluno,
                data_nascimento: values.apresentacao_data_nascimento,
                serie_turma: values.apresentacao_serie_turma,
                professor_srm: values.apresentacao_professor_srm,
                pedagogo_coordenador: values.apresentacao_pedagogo_coordenador,
                responsaveis_legais: values.apresentacao_responsaveis_legais
            })
        );

        item.append(
            "desempenho_academico_por_area_curricular",
            JSON.stringify(values.desempenho_academico_por_area_curricular || estadoInicial.desempenho_academico_por_area_curricular)
        );
        item.append(
            "intervencoes_na_sala_recursos_multifuncionais",
            JSON.stringify(
                values.intervencoes_na_sala_recursos_multifuncionais || estadoInicial.intervencoes_na_sala_recursos_multifuncionais
            )
        );
        item.append("consideracoes_gerais", values.consideracoes_gerais);

        axios({
            method: "put",
            url: "/api/relatorio-individual/alterar-relatorio-individual-fundamental",
            data: item
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Relatório alterado.");
                atualizarListagem();
                handleClose();
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    apresentacao: {
                        ...prevState.apresentacao,
                        ano_letivo: turma?.edicao || "",
                        aluno: aluno?.nome || "",
                        data_nascimento: aluno?.dataNascimento ? moment(aluno?.dataNascimento) : null,
                        serie_turma: turma?.nome || ""
                    }
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && !id) limparCampos();
    };

    const limparCampos = () => {
        resetFields();
        setRegisto(estadoInicial);
    };

    useEffect(() => {
        if (visible && id) carregarDetalhe(id);
        if (visible && !id) {
            limparCampos();
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            style={{ overflow: "auto", height: "calc(100% - 108px)", paddingBottom: "108px" }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="Apresentação">
                        <Form.Item label="Ano Letivo" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_ano_letivo", {
                                initialValue: registo.apresentacao.ano_letivo,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Bimestre" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_bimestre", {
                                initialValue: registo.apresentacao.bimestre,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Aluno(a)">
                            {getFieldDecorator("apresentacao_aluno", {
                                initialValue: registo.apresentacao.aluno,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Data de Nascimento" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_data_nascimento", {
                                initialValue: registo.apresentacao.data_nascimento,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Série/Turma" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_serie_turma", {
                                initialValue: registo.apresentacao.serie_turma,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) SRM">
                            {getFieldDecorator("apresentacao_professor_srm", {
                                initialValue: registo.apresentacao.professor_srm,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Pedagogo(a)/Coordenador(a)">
                            {getFieldDecorator("apresentacao_pedagogo_coordenador", {
                                initialValue: registo.apresentacao.pedagogo_coordenador,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Responsáveis Legais">
                            {getFieldDecorator("apresentacao_responsaveis_legais", {
                                initialValue: registo.apresentacao.responsaveis_legais,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="1. Desempenho Acadêmico por Área Curricular">
                        <Form.Item style={{ marginBottom: 20 }}>
                            {getFieldDecorator("desempenho_academico_por_area_curricular", {
                                initialValue: registo.desempenho_academico_por_area_curricular
                            })(<ListaDesempenhoArea />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="2. Intervenções na Sala de Recursos Multifuncionais">
                        <Form.Item style={{ marginBottom: 20 }}>
                            {getFieldDecorator("intervencoes_na_sala_recursos_multifuncionais", {
                                initialValue: registo.intervencoes_na_sala_recursos_multifuncionais
                            })(<ListaIntervencoesSRM />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="3. Considerações Gerais">
                        <Form.Item label="Descrição">
                            {getFieldDecorator("consideracoes_gerais", {
                                initialValue: registo.consideracoes_gerais
                            })(<TextArea rows={6} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>

                        <button className="botao-principal" type="submit" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-relatorio-bimestral-srm" })(DrawerRelatorioIrandubaFundamental);
